import React from 'react';
import { breakpoints, CancelIcon } from '@chegg-ui/theme';
import { createPortal } from 'react-dom';
import { useModalBehavior } from '../externals';
import { ConfirmationStyledModal, FullsizeContainer, ModalCenteringContainer, Title, Content, TopRightIconButton, ButtonAnimationContainer, ConfirmationModalButtons, ModalPadding, PresentationContent } from '../styles';

var ConfirmationModal = function ConfirmationModal(props) {
  var _useModalBehavior = useModalBehavior(props),
      closing = _useModalBehavior.closing,
      onModalKeyDown = _useModalBehavior.onModalKeyDown,
      modalRef = _useModalBehavior.modalRef;

  var id = props.id,
      children = props.children,
      className = props.className,
      dataTest = props['data-test'],
      isOpen = props.isOpen,
      onClose = props.onClose,
      title = props.title,
      ariaLabel = props['aria-label'],
      ariaDescribedby = props['aria-describedby'],
      _props$hideCloseButto = props.hideCloseButton,
      hideCloseButton = _props$hideCloseButto === void 0 ? false : _props$hideCloseButto,
      _props$shouldCloseOnC = props.shouldCloseOnClickOutside,
      shouldCloseOnClickOutside = _props$shouldCloseOnC === void 0 ? false : _props$shouldCloseOnC,
      _props$hideBackground = props.hideBackgroundOverlay,
      hideBackgroundOverlay = _props$hideBackground === void 0 ? false : _props$hideBackground,
      presentationContent = props.presentationContent,
      notifBanner = props.notifBanner,
      primaryActionButton = props.primaryActionButton,
      secondaryActionButton = props.secondaryActionButton,
      _props$buttonAlignmen = props.buttonAlignment,
      buttonAlignment = _props$buttonAlignmen === void 0 ? 'vertical' : _props$buttonAlignmen,
      selector = props.selector;
  var isMobileScreen = typeof window !== 'undefined' && window.matchMedia && window.matchMedia("(max-width: ".concat(breakpoints.sm.max, ")")).matches;
  var modalContent = /*#__PURE__*/React.createElement(FullsizeContainer, {
    onClick: shouldCloseOnClickOutside ? onClose : undefined,
    className: className,
    closing: closing,
    "data-test": "".concat(dataTest ? dataTest : id, "-container"),
    hideBackgroundOverlay: hideBackgroundOverlay // consistent naming needed across modals/dialogs to avoid making this element inert, see:
    // https://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/dialog.html
    ,
    id: "".concat(id, "-container")
  }, /*#__PURE__*/React.createElement(ModalCenteringContainer, {
    closing: closing
  }, /*#__PURE__*/React.createElement(ConfirmationStyledModal, {
    id: id,
    ref: modalRef,
    role: "alertdialog",
    "aria-modal": "true" // aria-label is needed only when there's no title, aria-labelledby needed only when there is
    ,
    "aria-label": title ? undefined : ariaLabel,
    "aria-labelledby": title ? "".concat(dataTest ? dataTest : id, "-title") : undefined,
    "aria-describedby": ariaDescribedby,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    onKeyDown: onModalKeyDown,
    "data-test": dataTest ? dataTest : undefined,
    hasCloseButton: !hideCloseButton
  }, /*#__PURE__*/React.createElement(ModalPadding, null, presentationContent && /*#__PURE__*/React.createElement(PresentationContent, null, /*#__PURE__*/React.cloneElement(presentationContent, {
    role: 'presentation'
  })), title && /*#__PURE__*/React.createElement(Title, {
    closing: closing
  }, title), /*#__PURE__*/React.createElement(Content, {
    closing: closing
  }, children), /*#__PURE__*/React.createElement(ButtonAnimationContainer, {
    closing: closing
  }, /*#__PURE__*/React.createElement(ConfirmationModalButtons, {
    alignment: buttonAlignment
  }, /*#__PURE__*/React.cloneElement(primaryActionButton, {
    size: 'medium'
  }), /*#__PURE__*/React.cloneElement(secondaryActionButton, {
    size: 'medium'
  }))), !hideCloseButton && /*#__PURE__*/React.createElement(TopRightIconButton, {
    onClick: onClose,
    screenReaderOnlyText: "close dialog",
    size: isMobileScreen ? 'small' : 'medium'
  }, /*#__PURE__*/React.createElement(CancelIcon, {
    id: "modalCloseIcon"
  }))), notifBanner)));

  if (!isOpen && !closing) {
    return null;
  }

  return /*#__PURE__*/createPortal(modalContent, selector && document.querySelector(selector) || document.body);
};

ConfirmationModal.displayName = 'ConfirmationModal';
export default ConfirmationModal;